// extracted by mini-css-extract-plugin
export var sectionWithPaddingTop = "logotypes-section-module--sectionWithPaddingTop--DtYmt";
export var sectionWithPaddingBottom = "logotypes-section-module--sectionWithPaddingBottom--+05si";
export var imageList = "logotypes-section-module--imageList--lqMYj";
export var imageListItem = "logotypes-section-module--imageListItem--z2vRC";